<mat-label>{{ label() }}</mat-label>

<button class="tree-select" [matMenuTriggerFor]="tree" #menuTrigger="matMenuTrigger">
  @if (!control.value.length) {
    <div class="placeholder">
      <p>{{ placeholder() }}</p>
      <mat-icon>arrow_drop_down</mat-icon>
    </div>
  }

  <mat-chip-set>
    @for (unit of control.value; track unit) {
      @if ($index < MAX_DISPLAY_CHIPS) {
        <mat-chip>
          {{ unit.label }}
        </mat-chip>
      }
    }
    @if ((control.value.length || 0) > MAX_DISPLAY_CHIPS) {
      <mat-chip>+ {{ (control.value.length || 0) - MAX_DISPLAY_CHIPS }}</mat-chip>
    }
  </mat-chip-set>
</button>

<mat-menu #tree="matMenu" xPosition="after" class="treeMenu">
  <tree
    (click)="$event.stopPropagation()"
    [closable]="true"
    (selectedCheckbox)="onSelectTreeItem($event)"
    [selected]="selectedItems"
    [fieldset]="false"
    [element]="entityType()"
    [elementSelectedType]="'node'"
    [labelSearch]="searchPlaceholder()"
    [maxHeight]="200"
    (closeComponent)="closeMenu()" />
</mat-menu>
